export const get = function (selector, id) {
    return paDom.get(selector, id);
};
export const paDom = {
    init() {
        window.paDom = this;
        let defaults = {
            wrapper: '#pa-engine-dom-wrapper',
            imagePreload: '#pa-engine-image-preload',
            placeholders: '.placeholder',
            tpls: 'template'
        };
        for (let id in defaults) {
            paDom.get(defaults[id], id);
        }
    },
    bind(el, callback, event) {
        event = event || 'click';
        if (typeof el.forEach != 'undefined') {
            el.forEach(function (el) {
                paDom._doBind(el, event, callback)
            })
        } else {
            paDom._doBind(el, event, callback)
        }
    },
    delegate(event, el, target, callback) {
        event = event || 'click';

        if (!paDom.isElement(el)) {
            el = paDom.get(el);
        }

        let delegateCallback = function (e) {
            let itsHim = false,
                foundTarget = null;

            if (target.substring(0, 1) == '.') {

                if (e.target.classList.contains(target.substring(1))) {
                    itsHim = true;
                    foundTarget = e.target;
                } else if (e.currentTarget.classList.contains(target.substring(1))) {
                    itsHim = true;
                    foundTarget = e.currentTarget;
                } else {
                    let path = e.path || (e.composedPath && e.composedPath()) || paDom.composedPath(e.target);
                    path.forEach(function (pathEl, pathI) {
                        if (pathEl.classList && pathEl.classList.contains(target.substring(1))) {
                            itsHim = true;
                            foundTarget = pathEl;
                        }
                    });
                }

            } else if (target.substring(0, 1) == '#') {
                if (e.target.id == target.substring(1)) {
                    itsHim = true;
                    foundTarget = e.target;
                } else if (e.currentTarget.id == target.substring(1)) {
                    itsHim = true;
                    foundTarget = e.currentTarget;
                } else {
                    let path = e.path || (e.composedPath && e.composedPath()) || paDom.composedPath(e.target);
                    path.forEach(function (pathEl, pathI) {
                        if (pathEl.id == target.substring(1)) {
                            itsHim = true;
                            foundTarget = pathEl;
                        }
                    });
                }
            }
            if (itsHim) {
                return callback.apply(foundTarget, arguments);
            }
        };

        paDom._doBind(el, event, delegateCallback)
    },
    /** Edge and IE fix **/
    composedPath(el) {
        let path = [];
        while (el) {
            path.push(el);
            if (el.tagName === 'HTML') {
                path.push(document);
                path.push(window);
                return path;
            }
            el = el.parentElement;
        }
    },
    on(event, el, callback) {
        let $el = paDom.get(el);
        paDom.bind($el, callback, event);
    },
    _doBind(el, event, callback) {
        el.addEventListener(event, callback);
    },
    nodeListFromArray(arr) {
        return Reflect.construct(Array, arr);
    },
    get(selector, id) {
        id = id || selector;

        if (paDom.isElement(selector)) {
            return selector;
        } else {

            if (typeof this[id] == 'undefined') {
                if (selector.substring(0, 1) == '#') {
                    let el = document.querySelector(selector);
                    if (!el) return;
                    this[id] = el;
                } else {
                    let els = document.querySelectorAll(selector);
                    if (!els) return;
                    this[id] = els;
                }
            }

        }

        return this[id];
    },
    onLoad(callback) {
        document.addEventListener('DOMContentLoaded', callback);
    },
    c(html, tag) {
        tag = tag || 'div';
        let newEl = document.createElement(tag);
        newEl.innerHTML = html;
        return newEl;
    },
    create(string) {
        return document.createRange().createContextualFragment(string);
    },
    isNode(o) {
        return (
            typeof Node === "object" ? o instanceof Node :
                o && typeof o === "object" && typeof o.nodeType === "number" && typeof o.nodeName === "string"
        );
    },
    isElement(o) {
        return (
            typeof HTMLElement === "object" ? o instanceof HTMLElement : //DOM2
                o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName === "string"
        );
    }

};


// WEBPACK FOOTER //
// ./src/js/framework/paDom.js